import React, { useState, useEffect, useRef } from "react";
import { connect, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

//ANT DESIGN IMPORTS
import {
  Input,
  Row,
  Typography,
  Col,
  Card,
  Table,
  Spin,
  Select,
  Button,
  Tooltip,
} from "antd";

//PROJECT IMPORTS
import { BOM } from "../../../../services/definedMethod";
import MainLayout from "../../../../components/layouts/MainLayout";
import TopContent from "../../../../components/layouts/TopContent";
import DownloadTableButtons from "../../../../components/DownloadTableButtons";
import cnt from "../../../../services/definedConstant";
import { apiConfig, labelConfig, staticConfig } from "../../customer.config";

const { Text, Link, Title } = Typography;

const ManageTermDepositAcc = (props) => {

  //DECLARED VARIABLES
  const { userData, rightBtn, rightAction } = props;
  const { session } = userData;
  const dispatch = useDispatch();
  const navigate = useNavigate();


  const [customerList, setCustomerList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [originalList, setOriginalList] = useState([]);
  const [tableCount, setTableCount] = useState("10");
  const [selectedRow, setSelectedRow] = useState(null);

  const columns = [
    {
      title: "Account Number",
      dataIndex: "accountNo",
    },

    {
      title: "Product Name",
      dataIndex: "productName",
    },
    {
      title: "Maturity Date",
      dataIndex: "maturityDate",
    },
    {
      title: "Status",
      dataIndex: "status",
    },
  ];

  useEffect(() => {
    // getSavingsAccountListAction();
    BOM.RightBtnAction(cnt.RIGHT_ADD_BTN);
  }, []);

  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value;

    if (!searchKey) {
      setCustomerList(originalList);
      return;
    }
    const filterBySearch = originalList.filter(
      (item) =>
        item?.key === parseInt(searchKey) ||
        item?.name.toLowerCase()?.includes(searchKey)
    );
    setCustomerList(filterBySearch);
  }

  function selectTableCount(value) {
    setTableCount(value);
  }
  const onSelectItemAction = (selectedRowKeys, objParam) => {
    //HOLD THE OBJECT SELECTED HERE
    setSelectedRow(objParam[0]);
    [cnt.RIGHT_DETAIL_BTN, cnt.RIGHT_EDIT_BTN].map((item) => {
      dispatch({
        type: item,
      });
    });
  };
  function handleOnCreate() {
    const { addBtn } = rightBtn;
    if (addBtn.toLowerCase() === "primary") {
      navigate("/new-term-deposit-account", { ofObj: selectedRow });
    } else {
      console.log("Could not open the link");
    }
  }
  return (
    <MainLayout isEnableRightSidebar={true} onAdd={handleOnCreate}>
      <TopContent
        pageTitle={labelConfig.manageDepositAccount}
        pageItems={staticConfig.manageDepositBreadcrumbItems}
      />

      {/* RENDER TABLE LIST */}
      <Card
        title={"Deposit Account List"}
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        <Spin spinning={isLoading} size="large">
          <Row style={{ marginBottom: 20 }}>
            <div style={{ marginBottom: "auto" }}>
              <Text>Show</Text>
              <Select
                defaultValue={tableCount}
                options={[
                  { value: "5", label: "5" },
                  { value: "10", label: "10" },
                  { value: "25", label: "25" },
                  { value: "50", label: "50" },
                ]}
                onSelect={selectTableCount}
              />
              <Text>Entries</Text>
            </div>

            <div style={{ margin: "0px 50px" }}>
              <Input
                onChange={handleSearchInTable}
                placeholder="Search by Name..."
                style={{
                  width: 400,
                }}
              />
            </div>
            {/* <DownloadTableButtons
              downloadData={customerList}
              columns={columns}
              fileName={"Customer List"}
            /> */}
          </Row>
          <Table
            rowSelection={{
              type: "radio",
              onChange: onSelectItemAction,
            }}
            columns={columns}
            dataSource={customerList}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: tableCount,
            }}
          />
        </Spin>
      </Card>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageTermDepositAcc);
